export default __webpack_public_path__ + "static/media/gallery_00.ec45e119.jpg";